import { render, staticRenderFns } from "./ImportKit.vue?vue&type=template&id=445d1196"
import script from "./ImportKit.vue?vue&type=script&lang=js"
export * from "./ImportKit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports